
import React, { createContext, useContext, useEffect } from 'react';
import { handleCSPReport } from '../utils/security';

const SecurityContext = createContext();

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (!context) {
    throw new Error('useSecurity must be used within SecurityProvider');
  }
  return context;
};

const SecurityProvider = ({ children }) => {
  useEffect(() => {
    // Listen for CSP violations (if reporting is enabled)
    const handleSecurityPolicyViolation = (event) => {
      handleCSPReport({
        blockedURI: event.blockedURI,
        violatedDirective: event.violatedDirective,
        originalPolicy: event.originalPolicy,
        disposition: event.disposition,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent,
        url: window.location.href
      });
    };

    document.addEventListener('securitypolicyviolation', handleSecurityPolicyViolation);

    // Security headers check (development only)
    if (process.env.NODE_ENV === 'development') {
      console.log('🔒 Security headers will be applied in production via Netlify');
    }

    return () => {
      document.removeEventListener('securitypolicyviolation', handleSecurityPolicyViolation);
    };
  }, []);

  const securityValue = {
    // Add security-related functions here if needed
  };

  return (
    <SecurityContext.Provider value={securityValue}>
      {children}
    </SecurityContext.Provider>
  );
};

export default SecurityProvider;
